import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvironmentService} from '@core/environment/environment.service';
import {Observable} from 'rxjs';
import {QuestionsWithMarkerBasicModel} from '@core/modules/rest/questions/response/questions-with-marker-basic.model';
import {LanguageEnum} from '@core/enums/language.enum';

@Injectable()
export class QuestionsRestService {

    private controllerUrl = this.environmentService.serverApiUrl + '/secured/questions';

    constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    }

    getAllQuestions(consentId: string, languageEnum: LanguageEnum): Observable<QuestionsWithMarkerBasicModel> {
        return this.httpClient.get<QuestionsWithMarkerBasicModel>(this.controllerUrl + `/${consentId}/${languageEnum}`);
    }
}

